import { render, staticRenderFns } from "./resultDialog.vue?vue&type=template&id=52dbeed3&scoped=true&"
import script from "./resultDialog.vue?vue&type=script&lang=js&"
export * from "./resultDialog.vue?vue&type=script&lang=js&"
import style0 from "./resultDialog.vue?vue&type=style&index=0&id=52dbeed3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52dbeed3",
  null
  
)

export default component.exports